import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { Typography } from '../Typography/Typography.js';

var _excluded = ["theme", "itemCount"];
/**
 * The page count component display collection of related items that has been split into individual pages.
 */
var PageCount = function PageCount(_ref) {
  var theme = _ref.theme,
    itemCount = _ref.itemCount,
    rest = _objectWithoutProperties(_ref, _excluded);
  var textColor = theme === 'on-dark' ? 'base.subtle' : 'base.inverted';
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    width: "fit-content",
    px: "8",
    py: "4",
    backgroundColor: theme === 'on-dark' ? 'base.overlay.inverted' : 'base.overlay',
    borderRadius: "base"
  }, rest), /*#__PURE__*/React.createElement(Typography, {
    tag: "span",
    variant: "body-s-strong",
    textColor: textColor
  }, itemCount));
};
PageCount.displayName = 'PageCount';

export { PageCount };
//# sourceMappingURL=PageCount.js.map
